import React from 'react'

import PropTypes from 'prop-types'

import Dialog from 'components/Dialog'

import ConsentPromptContent from '../ConsentPromptContent'

import Styles from './styles.scss'


export default function Modal({ ariaLabel, messageComponent }) {
  return (
    <Dialog
      ariaLabel={ ariaLabel }
      uiType="consent-banner"
    >
      <ConsentPromptContent
        messageComponent={ messageComponent }
        stylesOverrides={ Styles }
      />
    </Dialog>
  )
}

Modal.propTypes = {
  messageComponent: PropTypes.elementType.isRequired,

  ariaLabel: PropTypes.string,
}
